<template>
    <div class="bitacora">
        <!-- Diálogo de visualización -->
        <v-dialog v-model="dialogShowDocument" max-width="900px">
            <v-card>
                <v-toolbar flat color="primary" dark>
                <v-toolbar-title>Visualizador de Archivo</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Botón Descargar -->
                <!-- <v-btn icon @click="downloadFile" :disabled="!fileUrl">
                    <v-icon>cloud_download</v-icon>
                </v-btn> -->

                <!-- Botón Cerrar -->
                <v-btn icon @click="dialogShowDocument = false">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-toolbar>

                <v-card-text>
                <!-- PDF -->
                <div v-if="isPdf" style="height: 80vh;">
                    <iframe
                    :src="fileUrl"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    ></iframe>
                </div>

                <!-- Imagen -->
                <div v-else style="text-align: center;">
                    <img
                    :src="fileUrl"
                    alt="Imagen"
                    style="max-width: 100%; max-height: 80vh; border-radius: 8px;"
                    />
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>
      <!--    Diálogo Opciones   -->
        <v-dialog v-model="dialogReasons" persistent width="400">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('select_reason')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogReasons = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12>
                    <v-radio-group
                            v-model="reasons"
                            prepend-icon="fact_check"
                            name="reasons"
                            :mandatory="false"
                    >
                        <v-radio :label="$t('inappropriate_behavior')" :value="$t('inappropriate_behavior')"></v-radio>
                        <v-radio :label="$t('lack_equipment')" :value="$t('lack_equipment')"></v-radio>
                        <v-radio :label="$t('inconvenient_state_health')" :value="$t('inconvenient_state_health')"></v-radio>
                        <v-radio :label="$t('high_temperature')" :value="$t('high_temperature')"></v-radio>
                        <v-radio :label="$t('inconsistent_false_data')" :value="$t('inconsistent_false_data')"></v-radio>
                    </v-radio-group>
                </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            :loading="loading_reason"
                            @click="chooseReason"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
<!--                    <v-btn-->
<!--                            v-if="band_tolerance"-->
<!--                            color="success"-->
<!--                            x-small-->
<!--                            :loading="loading"-->
<!--                            @click="create_acceso_tolerance()"-->
<!--                    >{{$t('force_access')}}-->
<!--                    </v-btn>-->
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            v-if="survey"
                            color="primary"
                            x-small
                            @click="dialogShowSurvey = true"
                    >{{$t('answer')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', activar_camara = true, band_gafete = false, band_tolerance = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo para mostrar encusta COVID al Vigilante y asi pueda contestarla  -->
        <v-dialog v-model="dialogShowSurvey"
                  scrollable
                  persistent
                  width="800"
        >
          <v-card class="justify-center">
            <v-toolbar color="primary" dark>
              <v-icon>masks</v-icon><v-toolbar-title>{{$t('header_survey')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogShowSurvey = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              {{$t('top1_survey')}}
              <br><br>
              {{$t('top2_survey')}}
              <br>
              <br>
              <v-divider></v-divider>
              <br>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question1')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row1" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question2')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row2" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question3')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row3" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question4')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row4" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <br>
              {{$t('below_survey')}}
              <br><br>
              <strong class="text-xs-centers">{{$t('msg_below_survey')}}</strong><br><br>
              <strong>{{$t('nombre')}}: </strong>{{name}}
              <br>
              <strong>{{$t('Fecha')}}: </strong>{{dd}}/{{mm}}/{{yyyy}}
              <v-divider></v-divider>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center">
              <v-alert :value="contestado" type="error" class="black--text">
                  {{$t('msg_error_survey')}}
              </v-alert>
              <v-btn v-show="!contestado" @click="send" :loading="loading" block color="primary">{{$t('enviar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="dialogDocumentos" scrollable max-width="600px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        Documentos Adjuntos
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDocumentos = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap class="text-xs-center">
                        <v-flex v-for="(doc, key) in missingDocumentations" xs12 sm6 :key="`preview-${key}`" class="mb-4">
                            <v-card outlined class="pa-3">
                            <div class="font-weight-bold">{{ doc.name }}</div>
                            <div v-if="doc.file" class="grey--text text--darken-1 text-truncate" style="max-width: 100%;">
                                Archivo adjunto
                            </div>
                            <div v-else class="grey--text text--darken-1 text-truncate" style="max-width: 100%;">
                                No se adjuntó este documento
                            </div>
                            <v-btn
                                small
                                color="primary"
                                class="mt-2"
                                @click="openDialog(doc.file)"
                                :disabled="!doc.file"
                            >
                                Visualizar
                            </v-btn>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entrada" :color="info_invitation.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-alert
                            outline
                            :value="info_invitation.meetsTolerance"
                            color="error"
                            transition="scale-transition"
                            icon="new_releases"
                        >
                          {{$t('msg_out_date_within_tolerance')}}
                        </v-alert>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                                <v-btn
                                    color="primary"
                                    class="mt-2"
                                    v-if="info_invitation.documentationByInvitation.length > 0"
                                    :loading="loadingDocumentation"
                                    @click="showDocumentation()"
                                >
                                    Ver Documentos Adjuntos                                </v-btn>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>

                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('multiple_accesses')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.multiple_accesses ? $t('Si') : 'No'}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                                <v-layout align-center justify-center row wrap class="mt-4">
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                v-if="info_invitation.automovil"
                                                v-model="datos_coche"
                                                prepend-icon="directions_car"
                                                name="datos_coche"
                                                :label="$t('datos_coche')"
                                                :error-messages="errores.datos_coche"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                type="number"
                                                v-if="info_invitation.health_survey"
                                                v-model="temperature"
                                                prepend-icon="thermostat"
                                                name="temperature"
                                                :label="$t('temperature')"
                                                :error-messages="errores.temperature"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-alert
                            outline
                            :value="info_invitation.meetsTolerance"
                            color="error"
                            transition="scale-transition"
                            icon="new_releases"
                        >
                          {{$t('msg_out_date_within_tolerance')}}
                        </v-alert>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!info_invitation.authorized" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{info_invitation.count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="updateAccessforAccess(data_access[0].id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0 && countDown === 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_acceso()"
                            >
                                Notificar al anfitrión <br> autorizar acceso
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0 && countDown > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDown}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0 && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0 && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="updateAccessforAccess(data_access[0].id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    large
                                    :loading="loadingCountIn"
                                    color="primary"
                                    @click="updateCountEntrada()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                            <v-btn
                                      large
                                      color="error"
                                      @click="showOptions"
                              >
                                  <v-icon>block</v-icon>
                                  {{$t('deny_access')}}
                              </v-btn>
                            <v-btn
                                      v-if="sala_espera"
                                      large
                                      color="primary"
                                      :loading="loading"
                                      @click="enviarSalaEspera(), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false"
                              >
                                  <v-icon>living</v-icon>
                                  {{$t('send_waiting_room')}}
                              </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" :color="data_access[0].pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>
                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
<!--                        <v-layout align-center justify-center row wrap class="mt-4">-->
<!--                            <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                <v-text-field-->
<!--                                        v-if="info_invitation.automovil"-->
<!--                                        v-model="datos_coche"-->
<!--                                        prepend-icon="directions_car"-->
<!--                                        name="datos_coche"-->
<!--                                        :label="$t('datos_coche')"-->
<!--                                        :error-messages="errores.datos_coche"-->
<!--                                >-->
<!--                                </v-text-field>-->
<!--                            </v-flex>-->
<!--                            <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                <v-text-field-->
<!--                                        v-if="info_invitation.health_survey"-->
<!--                                        v-model="temperature"-->
<!--                                        type="number"-->
<!--                                        prepend-icon="thermostat"-->
<!--                                        name="temperature"-->
<!--                                        :label="$t('temperature')"-->
<!--                                        :error-messages="errores.temperature"-->
<!--                                >-->
<!--                                </v-text-field>-->
<!--                            </v-flex>-->
<!--                        </v-layout>-->
                        <br>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('celular')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('Area')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('Información de Acceso')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12>
                                <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de acceso')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_acceso}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_salida ? data_access[0].fecha_hora_salida : "Pendiente" }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Estado')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{data_access[0].estado == '1' ? "Adentro" : "Afuera"}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Pase de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].pase_salida ? "Firmado" : "No Firmado"}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!data_access[0].pase_salida" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{data_access[0].count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="data_access[0].pase_salida"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0 && countDownSign === 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_firmar()"
                            >
                                Notificar al anfitrión <br> firmar pase de salida
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0 && countDownSign > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDownSign}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count === 0"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    large
                                    :loading="loadingCount"
                                    color="primary"
                                    @click="updateCount()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container class="my-1">
            <v-card class="my-2">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('current_invitations')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap class="my-4" align-center justify-center fill-height>
                        <v-flex xs12>
                            <v-card-title class="justify-center">
                            <v-text-field
                                outlined
                                clearable
                                v-model="search"
                                append-icon="mdi-magnify"
                                :label="$t('Buscar')"
                                :placeholder="$t('Buscar')"
                            ></v-text-field>
                            </v-card-title>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12>
                            <v-data-table
                                    :headers="headers"
                                    :loading="loading_data_accesos_without_code"
                                    :items="accesos_without_code"
                                    :search="search"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_invit')"
                                    :no-results-text="`${$t('ningun_resultado_1')} &quot;${search}&quot; ${$t('ningun_resultado_2')}`"
                            >
                                <template v-slot:items="props">
                                    <td class="justify-center layout px-0">
                                        <v-btn
                                                v-if="getProfile.enable_parking && props.item.isParking"
                                                color="info"
                                                class="mr-2"
                                                small
                                                @click="openVehicleDetailsModal(props.item)"
                                        >
                                            <v-icon small>directions_car</v-icon>
                                        </v-btn>
                                        <v-btn
                                                color="primary"
                                                class="mr-2"
                                                @click="copyToClipBoard(props.item.qr_code)"
                                                :loading="loading"
                                        >
                                            {{$t('entradas_salidas')}}
                                        </v-btn>
                                    </td>
                                    <td>
                                        <v-chip :color="props.item.chipColor" text-color="white" small>
                                            {{ props.item.tipo }}
                                        </v-chip>
                                    </td>
                                    <td>{{ props.item.guestFirstName }} {{ props.item.guestLastName }}</td>
                                    <td v-if="canShowShipmentClientColumn">
                                        <span v-if="!props.item.isShipment">-</span>
                                        <span v-else-if="props.item.clients_count && props.item.clients_count > 1">
                                            <v-chip small color="primary" text-color="white" class="mr-2">
                                                {{ props.item.clients_count }} destinos
                                            </v-chip>
                                        </span>
                                        <span v-else>{{ props.item.client_name || '-' }}</span>
                                    </td>
                                    <td>{{ props.item.fechaEnvio }}</td>
                                    <td>{{ props.item.expiration }}</td>
                                    <td>{{ props.item.qr_code }}</td>
                                </template>
                                <template v-slot:no-results>
                                    <div class="text-xs-center pa-4 grey--text">
                                        <v-icon large color="grey lighten-1">search_off</v-icon>
                                        <div class="subheading mt-2">
                                            {{$t('ningun_resultado_1')}} <strong>"{{ search }}"</strong> {{$t('ningun_resultado_2')}}
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:no-data>
                                    <div class="text-xs-center pa-4 grey--text">
                                        <v-icon large color="grey lighten-1">inbox</v-icon>
                                        <div class="subheading mt-2">{{ $t('no_registros_invit') }}</div>
                                    </div>
                                </template>
                                <template v-slot:pageText="props">
                                    {{props.rowsPerPage}}
                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
        <!-- Modal para detalles del vehículo -->
        <v-dialog v-model="showVehicleDetailsModal" max-width="1020px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">local_shipping</v-icon>
                    <v-toolbar-title class="font-weight-bold">Detalles del transportista</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon color="red" @click="showVehicleDetailsModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <!-- Loading -->
                <v-card-text v-if="loadingVehicleDetails" class="text-xs-center pa-6">
                    <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                    <div class="caption grey--text mt-3">Cargando detalles...</div>
                </v-card-text>

                <v-card-text v-else class="pt-2 pb-1">
                    <v-layout row wrap class="mb-2">
                        <v-flex xs12 sm7 class="pa-2">
                            <v-subheader class="primary--text font-weight-bold pl-0">
                                <v-icon small class="mr-2" color="primary">person</v-icon>
                                Conductor
                            </v-subheader>
                            <v-divider class="mb-2"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="pa-2">
                                    <v-card outlined class="pa-3 elevation-0">
                                        <div class="caption grey--text">Nombre</div>
                                        <div class="body-2 font-weight-bold">{{ vehicleDetails.propietario }}</div>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 sm6 class="pa-2">
                                    <v-card outlined class="pa-3 elevation-0">
                                        <div class="caption grey--text">
                                            <v-icon small class="mr-1">phone</v-icon>Teléfono
                                        </div>
                                        <div class="body-2 font-weight-bold">{{ vehicleDetails.telefono }}</div>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm5 class="pa-2" v-if="vehicleDetails.ineUrl">
                            <v-subheader class="primary--text font-weight-bold pl-0">
                                <v-icon small class="mr-2" color="primary">badge</v-icon>
                                Identificación
                            </v-subheader>
                            <v-divider class="mb-2"></v-divider>
                            <v-card flat class="ine-detail-card">
                                <v-img
                                    :src="vehicleDetails.ineUrl"
                                    aspect-ratio="1.586"
                                    contain
                                    class="ine-detail-img"
                                ></v-img>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <!-- Sección: Vehículo -->
                    <v-subheader class="primary--text font-weight-bold pl-0 mt-2">
                        <v-icon small class="mr-2" color="primary">local_shipping</v-icon>
                        Vehículo
                    </v-subheader>
                    <v-divider class="mb-2"></v-divider>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">directions_car</v-icon>Placas
                                </div>
                                <div class="body-2 font-weight-bold text-uppercase">{{ vehicleDetails.placa }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">build</v-icon>Tipo/Especificaciones
                                </div>
                                <div class="body-2 font-weight-bold">{{ vehicleDetails.unitSpecs }}</div>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <!-- Sección: Invitación -->
                    <v-subheader class="primary--text font-weight-bold pl-0 mt-2">
                        <v-icon small class="mr-2" color="primary">event_note</v-icon>
                        Invitación
                    </v-subheader>
                    <v-divider class="mb-2"></v-divider>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 class="pa-2" v-if="vehicleDetails.asunto">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">subject</v-icon>Asunto
                                </div>
                                <div class="body-2">{{ vehicleDetails.asunto }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">schedule</v-icon>Horario
                                </div>
                                <div class="body-2">{{ vehicleDetails.horario }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2" v-if="vehicleDetails.companyName">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">business</v-icon>Empresa anfitriona
                                </div>
                                <div class="body-2">{{ vehicleDetails.companyName }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2" v-if="vehicleDetails.seccionParking">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">local_parking</v-icon>Sección
                                </div>
                                <div class="body-2 font-weight-bold">{{ vehicleDetails.seccionParking }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2" v-if="vehicleDetails.espacioCajon">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">local_parking</v-icon>Cajón asignado
                                </div>
                                <div class="body-2 font-weight-bold primary--text">{{ vehicleDetails.espacioCajon }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2" v-if="vehicleDetails.hostName">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">person_pin</v-icon>Anfitrión
                                </div>
                                <div class="body-2">{{ vehicleDetails.hostName }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2" v-if="vehicleDetails.hostPhone">
                            <v-card outlined class="pa-3 elevation-0">
                                <div class="caption grey--text">
                                    <v-icon small class="mr-1">phone</v-icon>Tel. anfitrión
                                </div>
                                <div class="body-2">{{ vehicleDetails.hostPhone }}</div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="justify-center pa-4">
                    <v-btn
                            large
                            color="primary"
                            @click="showVehicleDetailsModal = false"
                    >
                        <v-icon left>close</v-icon>
                        {{$t('cerrar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal for Shipments -->
        <AccessShipmentsModal v-if="showShipmentModal" :qr_code="selectedShipmentQr" ref="shipmentModal" @close="showShipmentModal = false; get_access_without_code_by_date()" />
        <!-- Modal for Parking -->
        <AccessParkingModal v-if="showParkingModal" :qr_code="selectedParkingQr" ref="parkingModal" @close="showParkingModal = false; get_access_without_code_by_date()" />
    </div>
</template>

<script>
    import '@/plugins/axios'
    import axios from 'axios'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'
    import AccessShipmentsModal from '@/components/vigilante/AccessShipmentsModal.vue'
    import AccessParkingModal from '@/components/vigilante/AccessParkingModal.vue'

    export default {
        name: "current_invitations",
        components: {
            AccessShipmentsModal,
            AccessParkingModal
        },
        data: () => ({
            headers: [],
            accesos_without_code: [],
            loading_data_accesos_without_code: false,
            qr_code: '',
            qr_code_aux: '',
            error: '',
            showShipmentModal: false,
            selectedShipmentQr: '',
            showParkingModal: false,
            selectedParkingQr: '',
            info_invitation: [],
            dialog: false,
            valido: false,
            id_vigilante: 0,
            salida: false,
            entrada: false,
            sala_espera: false,
            estado: '',
            motivo_no_firma: '',
            comentarios_VE: '',
            errores: [],
            datos_coche: '',
            equipo_por_invitacion: [],
            data_access: [],
            dialog_inicio: false,
            casetas: [],
            caseta: 0,
            loading_gafete: false,
            dialog_errores: false,
            errores_guard: '',
            head_color: '',
            band_gafete: false,
            band_tolerance: false,
            band_current_time: false,
            dialogIP: false,
            ip: '127.0.0.1',
            loading: false,
            loadingCount: false,
            loadingCountIn: false,
            dialogReasons: false,
            reasons: null,
            temperature: 0,
            loading_reason: false,
            row1: false,
            row2: false,
            row3: false,
            row4: false,
            dd: null,
            mm: null,
            yyyy: null,
            contestado: false,
            name: '',
            dialogShowSurvey: false,
            survey: false,
            countDown: 0,
            countDownSign: 0,
            labels: {
                ine_frente: 'INE Frente',
                ine_reverso: 'INE Reverso',
                foto_cara: 'Foto de Cara',
                dc3: 'DC3',
                imss: 'IMSS',
                curp: 'CURP',
                rfc: 'RFC',
                licencia: 'Licencia de Conducir',
            },
            files: {
                ine_frente: 'sdfasdf',
                ine_reverso: 'dfg',
                foto_cara: 'gdfsg',
                dc3: 'dfg',
                imss: 'dfsgdsfg',
                curp: 'dfsgdsf',
                rfc: 'dsfgsdfg',
                licencia: 'sdfg',
            },
            dialogDocumentos: false,
            dialogShowDocument: false,
            fileUrl: '',
            isPdf: false,
            missingDocumentations: [],
            loadingDocumentation: false,
            idUserByInvitation: 0,
            ineFront: {
                "id": 1000,
                "name": "INE Frente",
                "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
            },
            ineBack: {
                "id": 1001,
                "name": "INE Reverso",
                "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
            },
            search: '',
            showVehicleDetailsModal: false,
            loadingVehicleDetails: false,
            vehicleDetails: {
                placa: 'N/A',
                unitSpecs: 'N/A',
                propietario: 'N/A',
                telefono: 'N/A',
                horario: 'Todo el dia',
                asunto: '',
                espacioCajon: '',
                seccionParking: '',
                ineUrl: '',
                hostName: '',
                hostPhone: '',
                companyName: ''
            }
        }),
        created: function(){
            this.get_current_date()
            this.get_access_without_code_by_date()
            this.get_casetas()
            if(!this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null){
            this.dialog_inicio = true
            }
            if(localStorage.getItem('dirIP') === null){
                this.ip = "127.0.0.1"
            } else {
                this.ip = localStorage.getItem('dirIP')
            }
        },
        watch: {
          row1 (value) {
            this.contestado = value || this.row2 || this.row3 || this.row4
          },
          row2 (value) {
            this.contestado = this.row1 || value || this.row3 || this.row4
          },
          row3 (value) {
            this.contestado = this.row1 || this.row2 || value || this.row4
          },
          row4 (value) {
            this.contestado = this.row1 || this.row2 || this.row3 || value
          }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante']),
            canShowShipmentClientColumn () {
                const profile = this.getProfile || {}
                const isGuardRole = profile.roll === 2 || profile.roll === 9
                const shipmentsEnabled = profile.enable_shipments === true
                return isGuardRole && shipmentsEnabled
            }
        },
        beforeUpdate() {
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Tipo'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'fullName'
                },
                ...(this.canShowShipmentClientColumn ? [{
                    text: 'Planta destino',
                    align: 'left',
                    sortable: true,
                    value: 'client_name'
                }] : []),
                {
                    text: this.$t('fecha_envio'),
                    align: 'left',
                    sortable: true,
                    value: 'fechaEnvio'
                },
                {
                    text: this.$t('fecha_expiracion'),
                    align: 'left',
                    sortable: true,
                    value: 'expiration'
                },
                {
                    text: this.$t('qr_code'),
                    align: 'left',
                    sortable: true,
                    value: 'qr_code'
                }
            ]
        },
        methods:{
            openDialog(fileUrl) {
                // 🔧 Ajusta esta ruta a tu estructura de archivos
                this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
                this.fileUrl = fileUrl
                this.dialogShowDocument = true
            },
            showDocumentation() {
                this.loadingDocumentation = true
                try {
                    if (!this.info_invitation || !this.info_invitation.idUserGuest) {
                        throw new Error('No hay información de usuario disponible')
                    }
                    
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/get-documents-by-user/' + this.info_invitation.idUserGuest + '/',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log('Documentos obtenidos del servidor:', response.data)
                            this.missingDocumentations = this.compareDocumentation(this.info_invitation.documentationByInvitation, response.data)
                            this.loadingDocumentation = false
                        })
                        .catch(error => {
                            this.loadingDocumentation = false
                            console.error('Error al obtener documentos:', error)
                            this.$store.commit('setErrorMessage', 'Error al cargar los documentos')
                        })
                } catch(error) {
                    this.loadingDocumentation = false
                    console.error('Error en showDocumentation:', error)
                    this.$store.commit('setErrorMessage', error.message)
                }
            },
            compareDocumentation(documentationsByInvitation, documentationsByUser) {
            console.log('Empieza a comparar documentaciones')

                let missingDocumentations = []
                
                // Validar que los arrays existan y sean válidos
                if (!documentationsByInvitation || !Array.isArray(documentationsByInvitation)) {
                    console.warn('documentationsByInvitation no es un array válido:', documentationsByInvitation)
                    documentationsByInvitation = []
                }
                if (!documentationsByUser || !Array.isArray(documentationsByUser)) {
                    console.warn('documentationsByUser no es un array válido:', documentationsByUser)
                    documentationsByUser = []
                }

                for(let i = 0; i < documentationsByInvitation.length; i++) {
                    const invDoc = documentationsByInvitation[i]
                    
                    // Validar que el objeto tenga la estructura esperada
                    if (!invDoc || !invDoc.id) {
                        console.log('Documento inválido en documentationsByInvitation:', invDoc)
                        continue
                    }
                    
                    let foundUserDoc = null
                    for(let j = 0; j < documentationsByUser.length; j++) {
                        const userDoc = documentationsByUser[j]
                        if (!userDoc || !userDoc.idDocumentation) continue

                        if(invDoc.idDocumentation === userDoc.idDocumentation.id) {
                            foundUserDoc = userDoc
                            break
                        }
                    }
                    
                    if (foundUserDoc) {
                        missingDocumentations.push({
                            id: foundUserDoc.idDocumentation.id,
                            name: foundUserDoc.idDocumentation.name,
                            file: foundUserDoc.file
                        })
                    } else {
                        missingDocumentations.push({
                            id: invDoc.id,
                            name: invDoc.name,
                            file: null
                        })
                    }
                }
                
                // Agregar documentos de INE si existen
                if (this.info_invitation && this.info_invitation.guest_ine_frente) {
                    this.ineFront.file = this.info_invitation.guest_ine_frente
                    missingDocumentations.push(this.ineFront)
                }
                if (this.info_invitation && this.info_invitation.guest_ine_atras) {
                    this.ineBack.file = this.info_invitation.guest_ine_atras
                    missingDocumentations.push(this.ineBack)
                }
                
                console.log('missingDocumentations final = ', missingDocumentations)
                this.dialogDocumentos = true
                return missingDocumentations
            },
            countDownTimer() {
                if(this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            },
            countDownSignTimer() {
                if(this.countDownSign > 0) {
                    setTimeout(() => {
                        this.countDownSign -= 1
                        this.countDownSignTimer()
                    }, 1000)
                }
            },
            get_current_date () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              this.dd = dd
              this.mm = mm
              this.yyyy = yyyy
              return today
            },
            get_casetas: function(){
                this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                    .then(response => {
                        // Manejar múltiples formatos de respuesta
                        if (response && response.casetas && Array.isArray(response.casetas)) {
                            this.casetas = response.casetas
                        } else if (Array.isArray(response)) {
                            this.casetas = response
                        } else if (response && response.data && Array.isArray(response.data)) {
                            this.casetas = response.data
                        }
                        if (this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null) {
                            const casetasActivas = this.casetas.filter(c => c.activa)
                            if (casetasActivas.length === 1) {
                                const casetaId = casetasActivas[0].id
                                localStorage.setItem('id_caseta', casetaId)
                                this.caseta = casetaId
                                this.dialog_inicio = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_color', 'success')
                                this.$store.commit('snackbar_change_message', 'Caseta seleccionada correctamente')
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    this.dialog_inicio = false
                }
            },
            get_access_without_code_by_date: function () {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_invByDateRangeOnlyGuard',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_without_code = []
                        else
                            this.accesos_without_code = response.data.map(item => ({
                                ...item,
                                fullName: `${item.guestFirstName} ${item.guestLastName}`,
                                tipo: item.typeInv === 2 ? (this.$t ? this.$t('recurrente') : 'Empresa Recurrente') : (item.typeInv === 1 ? (this.$t ? this.$t('empresarial') : 'Empresarial') : (this.$t ? this.$t('normal') : 'Normal')),
                                chipColor: item.typeInv === 2 ? 'deep-purple' : (item.typeInv === 1 ? 'indigo' : 'blue')
                            }))
                        
                        // Cargar embarques si están habilitados
                        const profile = this.getProfile
                        if (profile && profile.enable_shipments) {
                            console.log('is_shipments_enabled', profile.enable_shipments)
                            this.get_shipments_invitations();
                        } else {
                            // Si no hay embarques, cargar directamente parqueos
                            this.get_parking_invitations_guard();
                        }
                    })
                    .catch(error => {
                        console.log('Error obteniendo invitaciones sin código:', error)
                        // EN CASO DE ERROR, SIGUE CARGANDO PARKING Y EMBARQUES
                        const profile = this.getProfile
                        if (profile && profile.enable_shipments) {
                            this.get_shipments_invitations();
                        } else {
                            this.get_parking_invitations_guard();
                        }
                    })

            },
            get_shipments_invitations: function() {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/guard/active-invitations/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status !== 204 && response.data) {
                            const shipmentItems = response.data.map(item => ({
                                ...item,
                                fullName: `${item.guest_first_name || item.client_name} ${item.guest_last_name || ''}`.trim(),
                                guestFirstName: item.guest_first_name || item.client_name,
                                guestLastName: item.guest_last_name || '',
                                fechaEnvio: `${item.window_date} ${item.window_time}`,
                                expiration: item.window_date,
                                qr_code: item.qr_code,
                                isShipment: true,
                                tipo: this.$t ? this.$t('shipments') : 'Embarques',
                                chipColor: 'orange'
                            }));
                            // IMPORTANTE: Filtrar embarques viejos antes de agregar nuevos (evita duplicados)
                            let currentList = this.accesos_without_code.filter(i => !i.isShipment);
                            this.accesos_without_code = [...currentList, ...shipmentItems];
                        }
                        // IMPORTANTE: Siempre cargar parqueos después de embarques
                        this.get_parking_invitations_guard();
                    })
                    .catch(error => {
                        console.log("Error fetch shipments:", error);
                        // En error, también cargar parqueos
                        this.get_parking_invitations_guard();
                    });
            },
            get_parking_invitations_guard: function(search_query = '') {
                // Remove ?search query since local v-data-table filtering handles searching and backend might be slow.
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/guard/list/?search=' + search_query,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status !== 204 && response.data) {
                            const parkingItems = response.data.map(item => ({
                                ...item,
                                fullName: `${item.guest_first_name || ''} ${item.guest_last_name || ''}`.trim(),
                                guestFirstName: item.guest_first_name,
                                guestLastName: item.guest_last_name,
                                fechaEnvio: item.invitation_date,
                                expiration: item.expiration,
                                qr_code: item.qr_code,
                                isParking: true,
                                tipo: this.$t ? this.$t('parking') : 'Estacionamiento',
                                chipColor: 'green'
                            }));
                            // We filter out any previous parking results from the list so they dont duplicate on reload
                            let currentList = this.accesos_without_code.filter(i => !i.isParking);
                            this.accesos_without_code = [...currentList, ...parkingItems];
                        }
                        this.loading_data_accesos_without_code = false;
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false;
                        console.log("Error fetch parking:", error);
                    });
            },
            copyToClipBoard: function(qrcode) {
                this.qr_code = qrcode
                
                if (qrcode && qrcode.startsWith('spmt_')) {
                    this.selectedShipmentQr = qrcode;
                    this.showShipmentModal = true;
                    // Need a short timeout for the ref to be available
                    setTimeout(() => {
                        if (this.$refs.shipmentModal) {
                            this.$refs.shipmentModal.qr_code = qrcode;
                        }
                    }, 50);
                    return;
                }
                if (qrcode && (qrcode.startsWith('prk_') || qrcode.startsWith('prk-'))) {
                    this.selectedParkingQr = qrcode;
                    this.showParkingModal = true;
                    setTimeout(() => {
                        if (this.$refs.parkingModal) {
                            this.$refs.parkingModal.qr_code = qrcode;
                        }
                    }, 50);
                    return;
                }
                
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + qrcode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.info_invitation = response.data
                        this.valido = true
                        console.log("Valido")
                        this.is_access_in_out_both()
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.request.status)
                        switch (error.request.status) {
                          case 404:
                            this.valido = false
                            console.log("No Valido")
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                          break;
                          case 401:
                            this.valido = false
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_empresa')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                          break;
                          case 423:
                            this.valido = false
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_confirmado')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                          break;
                          case 406:
                            this.valido = false
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('msg_canceled_invitation')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                          break;
                          case 409:
                            this.valido = false
                            this.clear_without_activate_camera2()
                            console.log(JSON.parse(error.request.response).status)
                            if (JSON.parse(error.request.response).status === 0) {
                              this.errores_guard =
                                  `
                                    <h4>${this.$t('msg_survey00')}</h4>
                                    <br><br>
                                    <h5>${this.$t('msg_survey')}</h5>
                                  `
                            }
                            if (JSON.parse(error.request.response).status === 1) {
                              this.errores_guard =
                                  `
                                      <h4>
                                          ${this.$t('msg_survey01')}
                                      </h4>
                                  `
                              this.name = JSON.parse(error.request.response).name
                              this.survey = true
                              this.idUserByInvitation = JSON.parse(error.request.response).idUserByInvitation
                            }
                            this.head_color = 'primary display-1 white--text justify-center'
                            this.dialog_errores = true
                          break;
                          case 403:
                            this.valido = false
                            this.clear_without_activate_camera()
                            console.log(JSON.parse(error.request.response).tipo)
                            let mensaje = JSON.parse(error.request.response).motivo
                            if (JSON.parse(error.request.response).tipo === 1) {
                              this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                            }
                            else {
                              this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                            }
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                          break;
                        }
                    })
            },
            qr_is_valid: function(info_invitation){
                console.log(Object.keys(info_invitation).length)
                if (Object.keys(info_invitation).length > 0) {
                    this.valido = true
                    console.log("Valido")
                    this.is_access_in_out_both()
                }
                else{
                    this.valido = false
                    console.log("NO Valido")
                    //     this.$store.commit('snackbar_activate_true')
                    //     this.$store.commit('snackbar_change_color', 'error')
                    //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
                    //     setTimeout(this.clear, 3000)
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                }
            },
            is_access_in_out_both: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.data_access = response.data
                          if (this.info_invitation.typeInv !== 2) { // Tipo de Invitación Normal
                            if (response.data.length > 0 && response.data[0].fecha_hora_acceso != null && response.data[0].fecha_hora_salida != null){
                              // alert('Ya se completó el acceso con la invitación Correspondiente.')
                              if (this.info_invitation.multiple_accesses === false) {
                                console.log('COMPLETO')
                                this.clear_without_activate_camera()
                                this.head_color = 'orange display-1 text--primary justify-center'
                                this.errores_guard =this.$t('mensaje_acceso_completo')
                                this.dialog_errores = true
                              } else {
                                this.entrada = true
                                this.sala_espera = true
                                this.salida = false
                                this.temperature = 0
                                this.datos_coche = ''
                                this.dialog = true
                                console.log('ENTRADA MULTIPLE')
                              }
                            }
                            else{
                              if(response.data.length > 0 ){
                                if (response.data[0].estado === 2) {
                                  this.clear_without_activate_camera()
                                  this.head_color = 'error display-1 text--primary justify-center'
                                  this.errores_guard = this.$t('msg_invitation_registered_denied') + response.data[0].comentarios_VE
                                  this.dialog_errores = true
                                  console.log('NEGADO')
                                } else
                                  if (response.data[0].estado === 5) {
                                    this.entrada = true
                                    this.sala_espera = false
                                    this.salida = false
                                    this.dialog = true
                                    console.log('ENTRADA DESDE SALA DE ESPERA')
                                  } else {
                                    this.entrada = false
                                    this.sala_espera = false
                                    this.salida = true
                                    this.dialog = true
                                    console.log('SALIDA')
                                  }
                              }
                              else{
                                this.entrada = true
                                this.sala_espera = true
                                this.salida = false
                                this.temperature = 0
                                this.datos_coche = ''
                                this.dialog = true
                                console.log('ENTRADA')
                              }
                            }
                          } else { // Invitación Recurrente
                            if (response.data.length === 0) {
                              this.entrada = true
                              this.sala_espera = true
                              this.salida = false
                              this.temperature = 0
                              this.datos_coche = ''
                              this.dialog = true
                              console.log('ENTRADA RECURRENTE')
                            } else {
                              if (response.data[0].estado === 1) {
                                this.entrada = false
                                this.sala_espera = false
                                this.salida = true
                                this.dialog = true
                                console.log('SALIDA RECURRENTE', response.data[0])
                              } else
                              if (response.data[0].estado === 5) {
                                this.entrada = true
                                this.sala_espera = false
                                this.salida = false
                                this.dialog = true
                                console.log('ENTRADA RECURRENTE DESDE SALA DE ESPERA', response.data[0])
                              } else {
                                if (response.data[0].estado !== 2) {  //CASO CUANDO SE HA COMPLETADO LA INVITACION RECURRENTE
                                  var fechaLocal = new Date(this.get_current_date_slash())
                                  const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                                  var fechaAccesoEntrada = new Date(readableDate)
                                  if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                                    this.entrada = true
                                    this.sala_espera = true
                                    this.salida = false
                                    this.temperature = 0
                                    this.datos_coche = ''
                                    this.dialog = true
                                    console.log('ENTRADA RECURRENTE')
                                  } else {
                                    if (this.info_invitation.multiple_accesses === false) {
                                      console.log('COMPLETO RECURRENTE')
                                      this.clear_without_activate_camera()
                                      this.head_color = 'orange display-1 text--primary justify-center'
                                      this.errores_guard = this.$t('mensaje_acceso_completo')
                                      this.dialog_errores = true
                                    } else {
                                      this.entrada = true
                                      this.sala_espera = true
                                      this.salida = false
                                      this.temperature = 0
                                      this.datos_coche = ''
                                      this.dialog = true
                                      console.log('ENTRADA RECURRENTE MULTIPLE')
                                    }
                                  }
                                } else { // CASO CUANDO LA INVITACION RECURRENTE HA SIDO NEGADA (NOTA: RECORDAR QUE CUANDO SE NIEGA EL ACCESO SOLO ES POR UN DIA)
                                  var fechaLocal3 = new Date(this.get_current_date_slash())
                                  const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                                  var fechaAccesoEntrada3 = new Date(readableDate)
                                  if (fechaAccesoEntrada3.getTime() !== fechaLocal3.getTime()) {
                                    this.entrada = true
                                    this.sala_espera = true
                                    this.salida = false
                                    this.temperature = 0
                                    this.datos_coche = ''
                                    this.dialog = true
                                    console.log('ENTRADA RECURRENTE')
                                  } else {
                                    this.clear_without_activate_camera()
                                    this.head_color = 'error display-1 text--primary justify-center'
                                    this.errores_guard = this.$t('msg_invitation_registered_denied') + response.data[0].comentarios_VE
                                    this.dialog_errores = true
                                    console.log('NEGADO')
                                  }
                                }
                              }
                            }
                          }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            create_acceso: function(id_invitacion){
                this.qr_code_aux = this.qr_code
                this.loading = true
                console.log(this.qr_code)
                var qrCode = this.qr_code
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresas/access/create',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        id_invitacion: id_invitacion,
                        qr_code: this.qr_code,
                        datos_coche: this.datos_coche,
                        id_guardhouse_checkin: localStorage.getItem('id_caseta'),
                        temperature: parseFloat(this.temperature, 10)
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        // this.dialog = false
                        // setTimeout(this.clear, 3000);
                        // console.log(this.info_invitation)
                        this.clear_without_activate_camera()
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.band_gafete = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        console.log(this.qr_code)
                        console.log('AQUI VAMOS')
                        console.log(this.qr_code)
                        this.clear_without_activate_camera2()
                        this.head_color = 'red display-1 text--primary justify-center'
                        console.log('Esta dentro de la tolerancia')
                        console.log(this.info_invitation.meetsTolerance)
                        console.log('Esta dentro de la tolerancia')
                        if (error.response.data.error === '!ACCESO NEGADO¡.Esta invitacion esta fuera de fecha.') {
                          this.band_tolerance = this.info_invitation.meetsTolerance
                        }
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            create_acceso_tolerance () {
                this.band_tolerance = false
                this.dialog_errores = false
                this.loading = true
                console.log(this.qr_code)
                var qrCode = this.qr_code
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresas/access/tolerance/create',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        id_invitacion: this.info_invitation.id,
                        qr_code: this.qr_code_aux,
                        datos_coche: this.datos_coche,
                        id_guardhouse_checkin: localStorage.getItem('id_caseta'),
                        temperature: parseFloat(this.temperature, 10)
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        // this.dialog = false
                        // setTimeout(this.clear, 3000);
                        // console.log(this.info_invitation)
                        this.clear_without_activate_camera()
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.band_gafete = true
                        this.band_current_time = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.clear_without_activate_camera()
                        this.head_color = 'red display-1 text--primary justify-center'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            enviarSalaEspera () {
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresas/access/create/waiting_room',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: this.qr_code,
                        estado: 5,
                        comentarios_VE: this.comentarios_VE
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        // this.dialog = false
                        // setTimeout(this.clear, 3000);
                        // console.log(this.info_invitation)
                        this.clear_without_activate_camera()
                        this.errores_guard = 'Enviado a la Sala de Espera Correctamente'
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.band_gafete = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.clear_without_activate_camera()
                        this.head_color = 'red display-1 text--primary justify-center'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            update_acceso (pk){
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/forExit/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        estado: 0,
                        motivo_no_firma: this.motivo_no_firma,
                        comentarios_VE: this.comentarios_VE,
                        id_guardhouse_checkout: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.errores_guard =this.$t('mensaje_alta_acceso_out')
                        this.dialog_errores = true
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
                        // setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })

            },
            updateAccessforAccess (pk){
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/forAccess/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        motivo_no_firma: this.motivo_no_firma,
                        comentarios_VE: this.comentarios_VE,
                        id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.band_gafete = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })

            },
            updateCount () {
                this.loadingCount = true
                const config2 = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.data_access = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.data_access = response2.data
                            console.log('Datos Accesos Count = ', response2.data[0])
                            }
                          else
                            this.data_access = response2.data
                        this.loadingCount = false
                    })
                    .catch(error => {
                        this.loadingCount = false
                        console.log(error)
                    })
            },
            updateCountEntrada () {
                this.loadingCountIn = true
                const config2 = {
                    method: 'get',
                    url:  'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.info_invitation = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.info_invitation = response2.data
                            console.log('Datos Invitacion Count = ', response2.data[0])
                            }
                          else
                            this.info_invitation = response2.data
                        this.loadingCountIn = false
                    })
                    .catch(error => {
                        this.loadingCountIn = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(){
                this.loading = true
                console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownSign = 30
                        this.countDownSignTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.data_access = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.data_access = response2.data
                                  }
                                  else
                                    this.data_access = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso de su invitado= ', this.info_invitation.id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccess/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDown = 30
                        this.countDownTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.info_invitation = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.info_invitation = response2.data
                                  }
                                  else
                                    this.info_invitation = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            clear_without_activate_camera: function () {
                this.dialog = false
                this.qr_code = ''
                this.entrada = false
                this.salida = false
                this.sala_espera = false
            },
            clear_without_activate_camera2: function () {
                this.dialog = false
                this.entrada = false
                this.salida = false
                this.sala_espera = false
            },
            clear() {
                this.dialog = false
                this.qr_code = ''
                this.entrada = false
                this.sala_espera = false
                this.salida = false
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            clear2() {
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            xOffset: function(pdf, text){
                console.log('Page width =', pdf.internal.pageSize.width/72)
                console.log('text width =', pdf.getStringUnitWidth(text))
                console.log('Font width =', pdf.internal.getFontSize())
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            download_gafete_original: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };

                toDataUrl(this.info_invitation.avatar, (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.empresa,
                        this.xOffset(pdf, this.info_invitation.empresa),
                        130)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Visitante'),
                        this.xOffset(pdf, this.$t('Visitante')),
                        145)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                        this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName) ,
                        160)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Anfitrion'),
                        this.xOffset(pdf, this.$t('Anfitrion')),
                        175)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                        this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                        190)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Area'),
                        this.xOffset(pdf, this.$t('Area')),
                        205)
                    pdf.setTextColor(this.info_invitation.areaColor)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.areaName.toUpperCase(),
                        this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                        220)
                    pdf.setTextColor('#000000')
                    pdf.text(this.$t('fecha_hora'),
                        this.xOffset(pdf, this.$t('fecha_hora')),
                        235)
                    pdf.setFontStyle("normal")
                    pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                        this.xOffset(pdf, this.info_invitation.dateInv + ' ' +  this.info_invitation.timeInv),
                        250)
                    pdf.setLineWidth(4.0)
                    pdf.setDrawColor(this.info_invitation.areaColor)
                    pdf.setFillColor('#FFFFFF')
                    pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                    toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                        pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50);
                        this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                            pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50);
                            pdf.save('gafete.pdf')
                        });
                    });
                    this.loading_gafete = false
                });
            },
            download_gafete: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };
                var pdf = new jsPDF('l', 'in', [288, 144])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    2.3,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(2.3, 0.42, 3.7, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(this.getCurrentDateSlash() + ' ' + this.getCurrentTime(), 2.7, 0.6)
                pdf.setFontSize(14)
                // pdf.setFillColor(255, 255, 255)
                // pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                // pdf.setFontStyle("bold")
                // pdf.text(this.info_invitation.empresa,
                //     this.xOffset(pdf, this.info_invitation.empresa),
                //     130)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    0.9)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                    this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName),
                    1.2)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
                pdf.setFontSize(14)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    1.45)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                    this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                    1.70)
                // pdf.setFontStyle("normal")
                // pdf.text(this.$t('Area'),
                //     this.xOffset(pdf, this.$t('Area')),
                //     205)
                // pdf.setTextColor(this.info_invitation.areaColor)
                // pdf.setFontStyle("bold")
                // pdf.text(this.info_invitation.areaName.toUpperCase(),
                //     this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                //     220)
                pdf.setTextColor('#000000')
                // pdf.setLineWidth(4.0)
                // pdf.setDrawColor(this.info_invitation.areaColor)
                // pdf.setFillColor('#FFFFFF')
                // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                // console.log(myBase64); // myBase64 is the base64 string
                // pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7);
                    pdf.save('gafete.pdf')
                    this.loading_gafete = false
                    this.band_current_time = false
                });
            },
            showOptions() {
              this.reasons = null
              this.dialogReasons = true
            },
            chooseReason () {
              console.log('Reason Choosen = ', this.reasons)
              this.loading_reason = true
              console.log(this.qr_code)
              const config = {
                method: 'post',
                url: 'https://empresa-service.intrare.app/empresas/access/create_deny_access',
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
                },
                data: {
                  id_invitacion: this.info_invitation.id,
                  qr_code: this.qr_code,
                  comentarios_VE: this.reasons,
                  estado: 2
                }
              }
              axios(config)
                  .then(response => {
                    this.loading_reason = false
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', this.$t('msg_host_notified_correctly'))
                    this.dialogReasons = false
                    setTimeout(this.clear, 3000)
                  })
                  .catch(error => {
                    this.loading_reason = false
                  })
            },
            get_current_date_slash () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              return today
            },
            getCurrentDateSlash () {
              var today = new Date()
              var aux = ''
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              aux = dd + '-' + mm + '-' + yyyy
              return aux
            },
            getCurrentTime () {
              var today = new Date()
              var aux = ''
              var hh = today.getHours()
              var mm = today.getMinutes()

              if (hh < 10) {
                hh = '0' + hh
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              aux = hh + ':' + mm
              return aux
            },
            send () {
              this.loading = true
              const config = {
                method: 'PATCH',
                url: 'https://empresa-service.intrare.app/empresas/health_survey/answered/' + this.idUserByInvitation,
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios(config)
                  .then(ok => {
                    this.loading = false
                    this.dialogShowSurvey = false
                    this.dialog_errores = false
                    this.survey = false
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', this.$t('survey_success'))
                    setTimeout(this.clear2, 3000)
                    this.copyToClipBoard(this.qr_code)
                  })
                  .catch(error => {
                    this.loading = false
                  })
            },
            openVehicleDetailsModal(item) {
                this.loadingVehicleDetails = true
                this.showVehicleDetailsModal = true
                // Fetch full details from backend
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/guard/qr/' + item.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        const d = response.data
                        const startTime = d.start_time ? String(d.start_time).split(':').slice(0, 2).join(':') : ''
                        const endTime = d.end_time ? String(d.end_time).split(':').slice(0, 2).join(':') : ''
                        this.vehicleDetails = {
                            placa: d.guest_plates || 'N/A',
                            unitSpecs: d.guest_unit_specs || 'N/A',
                            propietario: ((d.guest_first_name || '') + ' ' + (d.guest_last_name || '')).trim() || 'N/A',
                            telefono: d.guest_phone || 'N/A',
                            horario: (startTime && endTime) ? `${startTime} - ${endTime}` : (startTime || endTime || 'Todo el dia'),
                            asunto: d.subject || '',
                            espacioCajon: d.space_number || '',
                            seccionParking: d.section_name || '',
                            ineUrl: d.guest_id_front || '',
                            hostName: ((d.host_first_name || '') + ' ' + (d.host_last_name || '')).trim(),
                            hostPhone: d.host_phone || '',
                            companyName: d.company_name || ''
                        }
                    })
                    .catch(error => {
                        console.log('Error fetching parking detail:', error)
                        // Fallback to item data
                        this.vehicleDetails = {
                            placa: item.guest_plates || (item.vehicle_plate || item.plates) || 'N/A',
                            unitSpecs: item.guest_unit_specs || item.unit_specs || 'N/A',
                            propietario: ((item.guest_first_name || item.guestFirstName || '') + ' ' + (item.guest_last_name || item.guestLastName || '')).trim() || 'N/A',
                            telefono: item.guest_phone || item.telephone || 'N/A',
                            horario: 'Todo el dia',
                            asunto: item.subject || '',
                            espacioCajon: '',
                            seccionParking: '',
                            ineUrl: '',
                            hostName: '',
                            hostPhone: '',
                            companyName: item.company_name || ''
                        }
                    })
                    .finally(() => {
                        this.loadingVehicleDetails = false
                    })
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }

    /* Estilos para el modal de detalles del vehículo */
    .bordered {
        border-left: 4px solid #1976d2 !important;
        background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
        transition: all 0.3s ease;
    }

    .bordered:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
        border-left-color: #1565c0 !important;
    }

    .caption {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    .ine-detail-card {
        border-radius: 8px;
        overflow: hidden;
        background: #263238;
        max-width: 400px;
        margin: 0 auto;
    }
    .ine-detail-img {
        display: block;
    }
</style>
